<script setup lang="ts">
import { ref, computed } from 'vue';
import useGlobalStore from '@/store/globalStore';
import { useRouter } from 'vue-router';
import { $confirm } from '@nio-fe/lego';
import CouponPopover from '@/components/user/CouponPopover.vue';
import { useCouponStore } from '@/store/couponStore';
import useMatestoreStore from '@/store/matestoreStore';
import FeedbackDialog from '@/components/user/FeedbackDialog.vue';
import { doLogout } from '@/utils/logout_action';
const couponStore = useCouponStore();
const route = useRouter();
const globalStore = useGlobalStore();
const microStore = useMatestoreStore();

const props = withDefaults(
  defineProps<{
    theme: string;
  }>(),
  {
    theme: 'v1',
  }
);

const feedbackDialogRef = ref<typeof FeedbackDialog | null>(null);

const handleClickout = () => {
  console.log('out of element');
  if (couponStore.dialogOpened) {
    return;
  }
  popoverVisible.value = false;
};
const couponPopoverRef = ref<typeof CouponPopover | null>(null);
const popoverVisible = ref(false);
const hireDate = computed(() => {
  if (globalStore.getUserInfo.hireDate) {
    return parseInt(
      (Date.now() - Date.parse(globalStore.getUserInfo.hireDate)) /
        (1000 * 24 * 60 * 60) +
        ''
    );
  } else {
    return '-';
  }
});
function onSet() {
  route.push({ path: '/titsetting' });
  microStore.closeImMicro();
  popoverVisible.value = false;
  couponPopoverRef.value?.hidePopover();
}

const handleTogglePopover = () => {
  popoverVisible.value = !popoverVisible.value;
};

const handleShowCouponPopover = () => {
  if (!couponPopoverRef?.value?.getCurrentVisibleStatus()) {
    couponPopoverRef.value?.showPopover();
  } else {
    couponPopoverRef.value?.hidePopover();
  }
};

function onLogout() {
  $confirm('退出后，您将无法收到该账户的消息通知', '确定要退出登录吗？', {
    okText: '确认',
    cancelText: '取消',
    type: 'warning',
  }).then(() => {
    doLogout();
  });
}

const handleFetchCoupon = () => {
  couponStore.fetchEquityInfo();
};

const handleOpenFeedback = () => {
  feedbackDialogRef.value?.openDialog();
};
</script>
<template>
  <div>
    <n-popover
      :popper-style="{ zIndex: 2001 }"
      trigger="manual"
      :placement="theme === 'v1' ? 'bottom' : 'right-start'"
      :visible="popoverVisible"
      :arrow="false"
      :distance="10"
      @show="handleFetchCoupon"
    >
      <template #reference>
        <n-avatar
          class="titan-sidebar-user-avatar"
          size="small"
          @click="handleTogglePopover"
          :src="globalStore.userInfo.avatar"
        />
      </template>
      <template #popper>
        <div
          class="titan-sidebar-user-wrapper"
          v-click-outside="handleClickout"
        >
          <div class="titan-sidebar-user-box m-bottom-12">
            <div class="titan-sidebar-user-hire-date">
              今天是你与蔚来同行第<span class="hire-date-num">
                {{ hireDate }} </span
              >天！
            </div>
            <div class="titan-sidebar-user-cen">
              <n-avatar :src="globalStore.userInfo.avatar" />
              <div class="titan-sidebar-user-cen__user-info">
                <div>
                  {{ globalStore.domainDisplayName }}
                </div>
                <div>{{ globalStore.userInfo.nickName }}</div>
              </div>
            </div>
          </div>
          <div class="titan-sidebar-user-line"></div>
          <div class="titan-sidebar-user-box">
            <div class="titan-sidebar-user-operation">
              <div class="titan-sidebar-user-operation-item">
                <span>我的积分</span
                ><span class="user-op-item__value">{{
                  couponStore.creditAmount
                }}</span>
              </div>
              <div
                class="titan-sidebar-user-operation-item"
                v-tit-tracker:click="{
                  button_name: '我的卡券',
                  $screen_name: 'my',
                  trackName: 'MyClick',
                  requirement_id: 522,
                  track_sign: 'aplatform.b1506.click.MyClick',
                }"
                @click="handleShowCouponPopover"
              >
                <span>我的卡券</span
                ><span class="user-op-item__value">{{
                  couponStore.total
                }}</span>
              </div>
              <div
                class="titan-sidebar-user-operation-item"
                @click="handleOpenFeedback"
              >
                <span>帮助与反馈</span>
              </div>
              <div class="titan-sidebar-user-operation-item" @click="onSet">
                <span>设置</span>
              </div>
              <div class="titan-sidebar-user-operation-item" @click="onLogout">
                退出
              </div>
            </div>
          </div>
          <!--Should add to this place, align with trigger of popover-->
          <coupon-popover :theme="theme" ref="couponPopoverRef" />
        </div>
      </template>
    </n-popover>
    <feedback-dialog ref="feedbackDialogRef" />
  </div>
</template>
<style lang="scss" scoped>
.titan-sidebar-user-avatar {
  cursor: pointer;
  display: block;
}
.titan-sidebar-user-wrapper {
  box-sizing: border-box;
  width: 228px;
  background: #ffffff;
  box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.08), 0px 9px 28px rgba(0, 0, 0, 0.05),
    0px 12px 48px rgba(0, 0, 0, 0.03);
  border-radius: 8px;
  margin-right: 10px;
  padding: 18px 16px;

  .titan-sidebar-user-box {
    // padding: 0 12px;
    &.m-bottom-12 {
      margin-bottom: 12px;
    }
  }
  .titan-sidebar-user-line {
    height: 1px;
    background: #e9eaec;
    margin: 22px 0 12px;
    transform: matrix(1, 0, 0, -1, 0, 0);
  }
  .titan-sidebar-user-cen {
    display: flex;
    align-items: center;
    .n-avatar {
      margin-right: 10px;
    }
    .titan-sidebar-user-cen__user-info {
      flex: 1;
    }
  }
  .titan-sidebar-user-hire-date {
    font-weight: 400;
    font-size: 12px;
    letter-spacing: 0.5px;
    color: #242629;
    margin-bottom: 20px;
    .hire-date-num {
      font-size: 14px;
      font-weight: bold;
    }
  }
  .titan-sidebar-user-operation {
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    .titan-sidebar-user-operation-item {
      height: 38px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      padding: 8px 16px;
      > span {
        line-height: 22px;
      }
      &:hover {
        background: #f4f5f7;
        border-radius: 4px;
      }
      .el-link--inner {
        display: flex;
        justify-content: space-between;
      }
      .user-op-item__value {
        color: #929398;
      }
    }
  }
}
</style>
